import { render } from "./PediatricPage.vue?vue&type=template&id=15b4b99d"
import script from "./PediatricPage.vue?vue&type=script&lang=js"
export * from "./PediatricPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__